export default function EmergencyCTA() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="text-center md:text-left">
            <h3 className="text-3xl font-bold text-navy-950 mb-2">
              Need Immediate Marketing Help?
            </h3>
            <p className="text-xl text-gray-700">
              Our team is ready to audit your current marketing and show you quick wins
            </p>
          </div>
          <button
            onClick={() => scrollToSection('contact')}
            className="bg-red-500 text-white px-8 py-4 rounded-lg font-bold text-lg hover:bg-red-600 transition-all hover:shadow-xl whitespace-nowrap cursor-pointer flex-shrink-0"
          >
            Get Started Today
          </button>
        </div>
      </div>
    </section>
  );
}